const removeTokens = () => {
	localStorage.removeItem('refreshToken');
	localStorage.removeItem('googleIdToken');
};

export default removeTokens;
